import { useQuery } from "@tanstack/react-query";

import axios, { AxiosError } from "axios";

const usePlayerAvatar = (
  username?: string,
) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["userProfile", username],
    queryFn: () => getData(username),
    enabled: !!username,
    retry(failureCount, error) {

      if (failureCount > 5)
        return false

      if (error instanceof AxiosError && error.status == 401)
        return false

      return true
    },
  });

  return { data, isLoading, error};
};

const getData = async (username?: string) => {
  const response = await axios.get(
    `/user-profile/${username}/avatar/`
  );
  return response.data;
};

export default usePlayerAvatar;
